import { defineComponent as _defineComponent } from 'vue'
import useIcons from '@/composables/useIcons'
  import KetchUpButton from '@/components/common/KetchUpButton.vue'
  import useBreakpoint from '@/composables/useBreakpoint'
  import { UserModule } from '@/store/modules/user'
  import useCommonMixin from '@/composables/useCommonMixin'
  import SVGRenderer from '@/components/common/SVGRenderer.vue'
  import useI18n from '@/composables/useI18n'

  
export default /*#__PURE__*/_defineComponent({
  __name: 'UpgradePopup',
  props: {
    headerTitle: {
      required: true,
      type: String,
    },
    showFreeContentCopy: {
      type: Boolean,
      default: false,
    },
  },
  setup(__props) {

  

  const { isSmallerMobileDevice } = useBreakpoint()
  const { upsellImage, diamondIcon, specialBlackCheckmark } = useIcons()
  const { showVerifyEmailToasterMessage } = useCommonMixin()
  const { translateString } = useI18n()

  const checkedItems = [
    translateString('upsellSection.copyBlock.checkItem1'),
    translateString('upsellSection.copyBlock.checkItem2'),
    translateString('upsellSection.copyBlock.checkItem3'),
  ]

  const routeToPremium = () => {
    if (!UserModule.emailVerified) {
      showVerifyEmailToasterMessage()
      return
    }
    window.location.href = '/premium'
  }

return { __sfc: true,isSmallerMobileDevice, upsellImage, diamondIcon, specialBlackCheckmark, showVerifyEmailToasterMessage, translateString, checkedItems, routeToPremium, useIcons, KetchUpButton, useBreakpoint, UserModule, useCommonMixin, SVGRenderer, useI18n }
}

})